export default __webpack_public_path__ + "static/media/957.84fe5326.png";